export default __webpack_public_path__ + "img/ng200.1ba9153b.jpg";